module.exports = __webpack_public_path__ + "static/media/IMG_4606 length.bbbf0a38.JPG";